import images from "@assets/images";
import { CommonActions, useNavigation } from "@react-navigation/native";
import { DimensionContext } from "@src/DimensionProvider";
import { ImageButton06 } from "components/button";
import React from "react";
import { Image, Linking, Text, View } from "react-native";
import useStyles from "./styles.css";

const SignUpVerificationFailed = () => {
  const styles = useStyles();
  const navigation = useNavigation<any>();
  const { baseWidth } = React.useContext(DimensionContext);

  const onContactUs = () => {
    Linking.openURL("https://fortune8.online/contact-us");
  };

  const onPress = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [
          { name: "SignInOption" },
        ],
      })
    );
  };

  return (
    <View style={styles.viewEmail}>
      <Image
        source={{uri: images["gamezone-logo-horizontal"]}}
        style={styles.smallLogoContainer}
        resizeMode="stretch"
      />
      <View style={[styles.v_congrats]}>
        <Text style={[styles.t_thankyou, 
          { fontFamily: "Roboto-Bold", marginTop: "5%" },
          { fontSize: baseWidth * 0.035}]}>НЕУСПЕШНА ВЕРИФИКАЦИЯ</Text>
      </View>
      <View style={{ height: "8%"}} />
      <View style={{flexDirection: "row", alignItems: "center", justifyContent: "center", width: "100%"}}>
        <Image
          resizeMode="stretch"
          source={{uri: images["ic-circle-cross"]}}
          style={{width: baseWidth * 0.07, height: baseWidth * 0.07, marginRight: "2%"}}
        />
        <Text style={[styles.t_failed, {fontSize: baseWidth * 0.017}]}>
          Не успяхме да верифицираме имейла ти. Моля,{"\n"}
          опитай отново или използвай друг имейл{"\n"}
          адрес, за да се регистрираш.{"\n\n"}
          HИмаш проблеми със създаването на профил?{"\n"}
          <Text style={styles.t_failed_bold}
            suppressHighlighting onPress={onContactUs}>Свържи се с нас
          </Text>
        </Text>
      </View>
      <ImageButton06
        label="НАЗАД"
        onPress={onPress}
        style={styles.btn_login}
        width={baseWidth * 0.12}
        height={baseWidth * 0.05}
        source={images["btn-big"]}
        labelStyle={{fontSize: baseWidth * 0.012}}
      />
    </View>
  );
};

export default SignUpVerificationFailed;
